export {ChatViewComponent} from './ChatViewComponent';
export {ChatViewComponent as ChatView} from './ChatViewComponent';